module.exports = __webpack_public_path__ + "static/media/global_logo_light.cd81a1cf.svg";